import React from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import { CardMedia } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import api from './exhibitApi'

import './StoryCover.css'

export default function StoryLinkUrl({ story }) {

  const { image = '', title = '', collectionName = '' } = story ?? {}
  const src = api.image().imageUrl(`${image}`, 183, 100, window.devicePixelRatio) 

  return (
    <Card className='c-list' elevation={0} square={true} >
        <CardContent>
          <Typography className='c-label'>
            {collectionName}
          </Typography>
          <CardMedia>
            <a href={story.imageUrl}>
              <img
                className='c-list--media'
                src={ src } alt={title} />
              <Typography className='c-list--title'>
                {title}
              </Typography>
            </a>
          </CardMedia>
        </CardContent>
      </Card>
  )
}
